<template>
  <v-overlay color="white" :value="loading" z-index="999">
    <v-progress-circular color="dark-grey" indeterminate></v-progress-circular>
  </v-overlay>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LoaderView',
  computed: {
    ...mapState(['loading'])
  }
}
</script>

<style scoped></style>
